import type { OrganizationNumber } from '#shared/organization-number'
import { withPrefix } from '#shared/organization-number'
import { nullable, parse } from 'valibot'

export function useOrganization(
  organizationNumber: MaybeRef<OrganizationNumber | undefined | null>,
) {
  // Capture $coreApi in setup — Nuxt context is not preserved across async queryFn boundaries (cf. plugins/core-fetch.ts:46 runWithContext).
  const { $coreApi } = useNuxtApp()

  // eslint-disable-next-line @tanstack/query/exhaustive-deps -- $coreApi captured at setup time; stable identity, not a real dep
  return useQuery({
    queryKey: ['organization', organizationNumber],
    enabled: computed(() => !!unref(organizationNumber)),
    async queryFn({ signal }) {
      const rawOrganizationNumber = unref(organizationNumber)
      if (!rawOrganizationNumber) {
        return null
      }

      const res = await $coreApi.ecommerce(`/organizations/${withPrefix(rawOrganizationNumber)}`, {
        signal,
        onResponse: convert404to204,
      })

      return parse(nullable(organizationSchema), res ?? null)
    },
  })
}
